export interface SnackbarData {
  message: string;
}

export enum SnackbarResultStyle {
  SUCCESS = 'success-snack-bar',
  ERROR = 'error-snack-bar'
}
